
<template>
  <div class="page-wrapper">
    <NavBar class="style1" />
    <div class="content-wrapper">
      <PageTitle pageTitle="Chronos et Kairos" />
      <ChronosKairos/>
    </div>
    <FooterComp />
  </div>
</template>

<script>
import NavBar from '../Layouts/NavBar.vue'
import PageTitle from '../Common/PageTitle.vue'
import FooterComp from '../Layouts/FooterComp.vue'
import ChronosKairos from '../Chronos/ChronosKairos.vue'


export default {
  name: 'ChronosKairosPage',
  components: {
    NavBar,
    PageTitle,
    ChronosKairos,
    FooterComp,
  }
}
</script>